import React from 'react';
import { IconProps } from '../types';
const MinecraftEmptySlotSword: React.FC<IconProps> = ({ size = 24, className, style }) => (
<svg width={size} height={size} className={className} style={style} viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg">
<rect x="13" y="0" width="1" height="1" fill="rgba(85, 85, 85, 255)" />
<rect x="14" y="0" width="1" height="1" fill="rgba(85, 85, 85, 255)" />
<rect x="15" y="0" width="1" height="1" fill="rgba(85, 85, 85, 255)" />
<rect x="12" y="1" width="1" height="1" fill="rgba(85, 85, 85, 255)" />
<rect x="15" y="1" width="1" height="1" fill="rgba(85, 85, 85, 255)" />
<rect x="11" y="2" width="1" height="1" fill="rgba(85, 85, 85, 255)" />
<rect x="15" y="2" width="1" height="1" fill="rgba(85, 85, 85, 255)" />
<rect x="10" y="3" width="1" height="1" fill="rgba(85, 85, 85, 255)" />
<rect x="14" y="3" width="1" height="1" fill="rgba(85, 85, 85, 255)" />
<rect x="9" y="4" width="1" height="1" fill="rgba(85, 85, 85, 255)" />
<rect x="13" y="4" width="1" height="1" fill="rgba(85, 85, 85, 255)" />
<rect x="8" y="5" width="1" height="1" fill="rgba(85, 85, 85, 255)" />
<rect x="12" y="5" width="1" height="1" fill="rgba(85, 85, 85, 255)" />
<rect x="2" y="6" width="1" height="1" fill="rgba(85, 85, 85, 255)" />
<rect x="3" y="6" width="1" height="1" fill="rgba(85, 85, 85, 255)" />
<rect x="7" y="6" width="1" height="1" fill="rgba(85, 85, 85, 255)" />
<rect x="11" y="6" width="1" height="1" fill="rgba(85, 85, 85, 255)" />
<rect x="2" y="7" width="1" height="1" fill="rgba(85, 85, 85, 255)" />
<rect x="4" y="7" width="1" height="1" fill="rgba(85, 85, 85, 255)" />
<rect x="6" y="7" width="1" height="1" fill="rgba(85, 85, 85, 255)" />
<rect x="10" y="7" width="1" height="1" fill="rgba(85, 85, 85, 255)" />
<rect x="3" y="8" width="1" height="1" fill="rgba(85, 85, 85, 255)" />
<rect x="5" y="8" width="1" height="1" fill="rgba(85, 85, 85, 255)" />
<rect x="9" y="8" width="1" height="1" fill="rgba(85, 85, 85, 255)" />
<rect x="3" y="9" width="1" height="1" fill="rgba(85, 85, 85, 255)" />
<rect x="6" y="9" width="1" height="1" fill="rgba(85, 85, 85, 255)" />
<rect x="8" y="9" width="1" height="1" fill="rgba(85, 85, 85, 255)" />
<rect x="4" y="10" width="1" height="1" fill="rgba(85, 85, 85, 255)" />
<rect x="7" y="10" width="1" height="1" fill="rgba(85, 85, 85, 255)" />
<rect x="3" y="11" width="1" height="1" fill="rgba(85, 85, 85, 255)" />
<rect x="5" y="11" width="1" height="1" fill="rgba(85, 85, 85, 255)" />
<rect x="8" y="11" width="1" height="1" fill="rgba(85, 85, 85, 255)" />
<rect x="2" y="12" width="1" height="1" fill="rgba(85, 85, 85, 255)" />
<rect x="4" y="12" width="1" height="1" fill="rgba(85, 85, 85, 255)" />
<rect x="6" y="12" width="1" height="1" fill="rgba(85, 85, 85, 255)" />
<rect x="7" y="12" width="1" height="1" fill="rgba(85, 85, 85, 255)" />
<rect x="9" y="12" width="1" height="1" fill="rgba(85, 85, 85, 255)" />
<rect x="0" y="13" width="1" height="1" fill="rgba(85, 85, 85, 255)" />
<rect x="1" y="13" width="1" height="1" fill="rgba(85, 85, 85, 255)" />
<rect x="3" y="13" width="1" height="1" fill="rgba(85, 85, 85, 255)" />
<rect x="8" y="13" width="1" height="1" fill="rgba(85, 85, 85, 255)" />
<rect x="9" y="13" width="1" height="1" fill="rgba(85, 85, 85, 255)" />
<rect x="0" y="14" width="1" height="1" fill="rgba(85, 85, 85, 255)" />
<rect x="2" y="14" width="1" height="1" fill="rgba(85, 85, 85, 255)" />
<rect x="0" y="15" width="1" height="1" fill="rgba(85, 85, 85, 255)" />
<rect x="1" y="15" width="1" height="1" fill="rgba(85, 85, 85, 255)" />
<rect x="2" y="15" width="1" height="1" fill="rgba(85, 85, 85, 255)" />
</svg>);
export default MinecraftEmptySlotSword;